import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MoneyHandTYP from '../assets/images/moneyhandthankyoupage.svg';
import ThanksTextImage from '../assets/images/thanks.svg';
import HandThankYouPage from '../assets/images/handthankyoupage.svg';
import ColorsTYP from '../assets/images/colors.svg';
import SearchTYP from '../assets/images/searchimagethankyoupage.svg';
import InspiraLogo from '../assets/images/inspira_logo.png';
import { motion } from 'framer-motion';

export default function ThankYou() {
    const { id } = useParams();
    const [donationData, setDonationData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Simulación local: reemplaza con fetch real si es necesario
        const fetchDonation = async () => {
            try {
                const response = await axios.get(`https://admin-django-inspira.azurewebsites.net/api/donations/detail/${id}/`);
                setDonationData(response.data);
                // const fakeDonation = {
                //     id: 'demo123',
                //     created_at: '2025-06-17T18:40:00',
                //     donor: { nickname: 'Amigue Donador' },
                //     transaction: {
                //         payment_method: 'Tarjeta de crédito',
                //         amount: 250.00
                //     }
                // };
                // setDonationData(fakeDonation);
            } catch (err) {
                console.error('Error al obtener la donación:', err);
                setError('No se pudo cargar la donación');
            } finally {
                setLoading(false);
            }
        };

        fetchDonation();
    }, [id]);

    if (loading) return <p>Cargando...</p>;
    if (error || !donationData) return <p>{error || 'Datos no disponibles'}</p>;

    const fechaFormateada = new Date(donationData.created_at).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const transactionData = {
        id_transaction: donationData.id,
        date: fechaFormateada,
        method: donationData.transaction?.payment_method,
        amount: donationData.transaction?.amount
    };

    // const handleInvoiceRequest = () => {
    //     const phoneNumber = '525540328901';
    //     const message = `Hola, solicito factura para mi donación (ID: ${transactionData.id_transaction}). Mi RFC es: `;
    //     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    //     window.open(whatsappUrl, '_blank');
    // };

    return (
        <div className="min-h-screen bg-gray-50 py-12 mx-auto sm:px-6 lg:pl-24">
            <motion.div
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: true, amount: 0.4 }}
                className='lg:visible w-full lg:flex flex-col mx-auto justify-center hidden'>
                <div className='w-full flex justify-center items-center'>
                    <div className='w-9/12 flex flex-col justify-end items-center'>
                        <img
                            src={ThanksTextImage}
                            alt={'Gracias texto'}
                            className='w-7/12'
                        />
                        <div className='w-5/12'>
                            <p className='font-lato text-xl font-bold pl-1'>Gracias {donationData.donor?.nickname}, tu donación es fundamental para continuar nuestra labor. </p>
                        </div>
                    </div>
                    <div className='w-3/12 relative'>
                        <img
                            src={MoneyHandTYP}
                            alt='Mano'
                            className='w-6/12 absolute top-[-126px] left-[-190px]'
                        />
                        <img
                            src={ColorsTYP}
                            alt='Mano'
                            className='w-3/12 absolute bottom-[34px] left-[-190px]'
                        />
                        <img
                            src={SearchTYP}
                            alt='Mano'
                            className='w-4/12 absolute bottom-[-126px] left-[-52px]'
                        />
                    </div>
                </div>
                <div className='w-full flex justify-start pl-40'>
                    <div className='w-2/12 relative pr-52'>
                        <img
                            src={HandThankYouPage}
                            alt='Creativo Thank You Page'
                            className='w-9/12 absolute bottom-[61px] left-[-9px]'
                        />
                    </div>
                    <div className="space-y-4 w-7/12 justify-center p-10 font-lato">
                        <div className="flex justify-between">
                            <span className="text-gray-600">Número de transacción</span>
                            <span className="font-bold">{transactionData.id_transaction}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Fecha</span>
                            <span className="font-bold">{transactionData.date}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Método de pago</span>
                            <span className="font-bold">{transactionData.method}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Monto</span>
                            <span className="font-bold">${transactionData.amount} MXN</span>
                        </div>
                    </div>
                </div>
            </motion.div>
            <motion.div initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: true, amount: 0.4 }} className='lg:hidden w-full flex mx-auto flex-col justify-center items-center space-y-5'>
                <motion.img
                    src={InspiraLogo}
                    alt='logo de Inspira'
                    className='w-3/12'
                    initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 70 }}
                />
                <motion.img
                    src={ThanksTextImage}
                    alt='Texto de gracias'
                    className='w-10/12'
                />
                <div className='flex justify-center'>
                    <p className='font-lato text-sm font-bold w-8/12 text-center'>Gracias {donationData.donor?.nickname}, tu donación es fundamental para continuar nuestra labor. </p>
                </div>
                <div className="space-y-4 w-10/12 justify-center font-lato mt-16">
                    <div className="flex justify-between">
                        <span className="text-gray-600">Número de transacción</span>
                        <span className="font-bold">{transactionData.id_transaction}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-600">Fecha</span>
                        <span className="font-bold">{transactionData.date}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-600">Método de pago</span>
                        <span className="font-bold">{transactionData.method}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-600">Monto</span>
                        <span className="font-bold">${transactionData.amount} MXN</span>
                    </div>
                </div>
                <div className='relative w-10/12 flex'>
                    <img
                        src={HandThankYouPage}
                        alt='Imagen mano'
                        className='w-5/12'
                    />
                    <img
                        src={MoneyHandTYP}
                        alt='Imagen Mano con dinero'
                        className='w-4/12 align-bottom pt-11'
                    />
                    <img
                        src={SearchTYP}
                        alt='Creativo de busqueda'
                        className='w-3/12 absolute bottom-0 left-64 md:left-[464px]'
                    />
                </div>
            </motion.div>
        </div >
    );
}
